import type { ReactNode } from 'react';
import { useConnectivity } from '../lib/connectivity';

/** Standardgrund, wenn eine Aktion Netz braucht. */
export const OFFLINE_REASON = 'Braucht Netz.';

/**
 * Für Aktionen, die nur mit Netz gehen (Speichern, Senden): Ohne Netz ist der Knopf gesperrt und ein Grund steht daneben,
 * statt dass nach dem Zeitlimit eine rohe Fehlermeldung kommt. „Schwaches Netz“ sperrt nicht: Die Anfrage hat ihr eigenes
 * Zeitlimit und eine klare Meldung.
 *
 * Gebrauch: `const { disabled } = useOnlineAction(); <button disabled={disabled || busy}>` und darunter `<OfflineReason />`.
 */
export function useOnlineAction(): { disabled: boolean; reason: string | null } {
  const state = useConnectivity();
  const offline = state === 'offline';
  return { disabled: offline, reason: offline ? OFFLINE_REASON : null };
}

/**
 * Der Grund unter einem gesperrten Knopf. Zeigt nichts, solange Netz da ist. `keeps` sagt, was erhalten bleibt (z. B. „Ihre
 * Zählung bleibt auf diesem Gerät, bis Sie speichern.“).
 */
export function OfflineReason({ keeps, id }: { keeps?: ReactNode; id?: string }) {
  const { reason } = useOnlineAction();
  if (reason === null) return null;
  return (
    <p className="offline-reason muted" role="status" {...(id === undefined ? {} : { id })}>
      {reason} {keeps}
    </p>
  );
}
